import { Pipe, PipeTransform } from '@angular/core';
import { Currency, CurrencyCountryCodes } from './currency-country-codes';
import { DecoratedCurrency } from './decorated-currency';

@Pipe({
    name: 'currency-country-code-decorator'
})
export class CurrencyCountryDecoratorPipe implements PipeTransform {
    transform(currency: Currency): DecoratedCurrency {
        const decoratedCurrency = CurrencyCountryCodes.get(currency);
        return decoratedCurrency
            ? decoratedCurrency
            : { countryCode: '', description: '', symbol: currency };
    }
}
